import crypto from 'crypto';

export function hashDigest(data: string): string {
  return crypto.createHash('SHA256').update(data, 'utf-8').digest('hex').toString();
}
